import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initState = {
  search: {
    page: 1,
    query: "",
    limit: 10,
    category: 0,
  },
  content: {
    tab: "th",
    mkt_content_local: "",
    mkt_content_en: "",
  },
  mobileModal: {
    isOpen: false,
    productData: null,
  },
};

const MKTProductSlice = createSlice({
  name: "product",
  initialState: initState,
  reducers: {
    SET_SEARCH: (state, { payload }) => {
      state.search = { ...state.search, ...payload };
    },

    SET_CONTENT: (state, { payload }) => {
      state.content = { ...state.content, ...payload };
    },

    LOAD_CONTENT: (state, { payload }) => {
      state.content = { ...initState.content, ...payload };
    },

    OPEN_MOBILE_MODAL: (state, { payload }) => {
      const parseMoment = (v) => (v ? moment(v) : null);

      state.mobileModal.isOpen = true;
      state.mobileModal.productData = {
        ...payload,
        start_date: parseMoment(payload.start_date),
        end_date: parseMoment(payload.end_date),
      };
    },

    CLOSE_MOBILE_MODAL: (state) => {
      state.mobileModal = initState.mobileModal;
    },

    UPDATE_MOBILE_MODAL_DATA: (state, { payload }) => {
      if (state.mobileModal.productData) {
        state.mobileModal.productData[payload.field] = payload.value;
      }
    },
  },
});

export const actionMKTProduct = MKTProductSlice.actions;

export const searchSelector = (state) => state.marketing.product.search;
export const contentSelector = (state) => state.marketing.product.content;
export const mobileModalSelector = (state) => state.marketing.product.mobileModal;

const MKTProductReducer = MKTProductSlice.reducer;

export default MKTProductReducer;
